import type { TaskCommentDto } from './schemas/task.js';

/** Shown when marking a task done without any user comment. */
export const TASK_CLOSE_NO_COMMENT_CONFIRM =
  'Добавьте комментарий со ссылкой на результат.\n\nЗакрыть задачу без комментария?';

export function isUserTaskComment(comment: Pick<TaskCommentDto, 'kind'>): boolean {
  return comment.kind === 'user';
}

/** True when the task has at least one user comment (status lines do not count). */
export function taskHasUserComment(comments: Pick<TaskCommentDto, 'kind'>[]): boolean {
  return comments.some(isUserTaskComment);
}
